import SEOHead from '@/components/feature/SEOHead';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactForm from './components/ContactForm';

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们 - 禁漫天堂"
        description="禁漫天堂成立于2018年，是国内领先的成人漫画阅读平台。了解禁漫天堂的品牌故事、平台口碑及联系方式，联系我们获取帮助与支持。"
        keywords="禁漫天堂关于我们,禁漫天堂联系方式,禁漫天堂品牌介绍,禁漫天堂客服"
        canonicalPath="/about"
        schema={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于禁漫天堂',
            description: '禁漫天堂成立于2018年，是国内领先的成人漫画阅读平台，拥有超过10万部漫画资源和500万注册用户。',
            url: 'https://jmtthub.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '禁漫天堂',
              url: 'https://jmtthub.com',
            },
          },
        ]}
      />

      <main className="pt-20">
        <div className="w-full px-4 md:px-6">
          <Breadcrumbs
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>
        <BrandIntro />
        <Reputation />
        <ContactForm />
      </main>
    </>
  );
}